import React from 'react';
import PropTypes from 'prop-types';
import './Spinner.scss';

const spinner = require('./assets/spinner.svg');

const propTypes = {
  size: PropTypes.string,
};

const defaultProps = {
  size: '100px',
};
const componentName = ({ size }) => (
  <div style={{ width: size }} className="spinner-wrapper"><img src={spinner} alt="spinner" /></div>
);


componentName.propTypes = propTypes;
componentName.defaultProps = defaultProps;

export default componentName;



// WEBPACK FOOTER //
// ./src/components/_atomic/Spinner/Spinner.js